import { render, staticRenderFns } from "./blogdetail.vue?vue&type=template&id=26ae6086&"
import script from "./blogdetail.vue?vue&type=script&lang=js&"
export * from "./blogdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports